import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { motion } from "framer-motion";
import "./EducationSection.css";


import Layout from "../../layouts/Layout";
import BreadcrumbArea from "../../components/BreadcrumbArea/BreadcrumbArea";
import EducationOverview from "./EducationOverview";
import EducationalHistory from "./EducationalHistory";
import MentorTalk from "./MentorTalk";
function EducationSection() {
  const timelineElements = [
    {
      title: "Junior Developer",
      location: "Surampalem, India",
      date: "2025 - Present",
      description: [
        "Developed and maintained responsive web applications using modern front-end technologies.",
        "Collaborated with cross-functional teams to design and implement new features.",
        "Optimized application performance through code refactoring and implementing best practices.",
        "Managed project timelines and deliverables, ensuring timely completion of tasks.",
      ],
    },
    {
      title: "Frontend Development Intern",
      location: "Surampalem, India",
      date: "2024 - 2025",
      description: [
        "Assisted in the development of user-friendly interfaces using HTML, CSS, and JavaScript.",
        "Implemented state management solutions to enhance application performance.",
        "Worked on authentication and authorization mechanisms to secure applications.",
        "Collaborated with designers to create responsive and visually appealing web designs.",
      ],
    },
    {
      title: "DSA Intern",
      location: "Surampalem, India",
      date: "2024 (Feb - June)",
      description: [
        "Trained 180 students in Data Structures and Algorithms (DSA) through hands-on sessions.",
        "Mentored 80 B.Tech students in Data Structures using C, improving their coding skills.",
        "Solved complex problems using data structures and algorithms.",
        "Participated in coding contests to enhance problem-solving skills.",
      ],
    },
    {
      title: "AIML Trainee",
      location: "Surampalem, India",
      date: "2023 - 2024",
      description: [
        "Studied and implemented machine learning models for classification and regression tasks.",
        "Explored neural networks and deep learning techniques for image and text processing.",
        "Collaborated with mentors to understand and apply advanced AI concepts.",
      ],
    },
  ];

  return (
    <div style={{ backgroundColor: "#292930" }}>
      <Layout header={1} footer={1} className="" mainClassName="">
        <BreadcrumbArea
          title={"Education Details"}
          subtitle={"Education"}
          className={"breadcrumb-area-two pt-175"}
          showShape={false}
        />
        <motion.div
          id="history"
          className="timeline-container"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "linear" }}
          viewport={{ once: true }}
        >
          <EducationOverview />
          <div style={{ backgroundColor: "#292930", minHeight: "100vh" }}>
            <EducationalHistory />
          </div>
        </motion.div>
        {/* <Portfolio /> */}
        <MentorTalk />
      </Layout>
    </div>
  );
}

export default EducationSection;
